const empleadosActivos = [
  {
    idEmpleado: 1,
    token: null,
    caldenON: 0,
    imaMobile: 0,
    salesman_PermiteModificarPrecio: false,
    idGrupoVendedores: null,
    legajo: null,
    nombreEmpleado: "AONIKEN",
    esVendedor: false,
    password: null,
    autorizaDespachoManual: false,
  },
  {
    idEmpleado: 2,
    token: null,
    caldenON: 0,
    imaMobile: 0,
    salesman_PermiteModificarPrecio: false,
    idGrupoVendedores: null,
    legajo: null,
    nombreEmpleado: "PEREZ, ELIZABETH",
    esVendedor: false,
    password: null,
    autorizaDespachoManual: false,
  },
  {
    idEmpleado: 3,
    token: null,
    caldenON: 0,
    imaMobile: 0,
    salesman_PermiteModificarPrecio: false,
    idGrupoVendedores: null,
    legajo: null,
    nombreEmpleado: "SANCHEZ, SOFIA",
    esVendedor: false,
    password: null,
    autorizaDespachoManual: false,
  },
];

const getEmpleadosActivos = async () => {
  return empleadosActivos;
};

const empleados = {
  getEmpleadosActivos,
};

export default empleados;
